import { Div } from "@tblabs/truffle";


export class Page extends Div
{
    public header: Div;
    public body: Div;
    public footer: Div;

    constructor(private pageTitle: string, private cssClass?: string)
    {
        super();
        this.Class("page");

        document.title = this.pageTitle;

        this.header = new Div(this.cssClass + " header").Text(this.pageTitle);
        this.body = new Div(this.cssClass + " body");
        this.footer = new Div(this.cssClass + " footer");


        this.Append(
            new Div("content")
                .Append(
                    new Div("content-inside")
                        .Append(
                            this.header,
                            this.body,
                        )),
            this.footer,
        );
    }
}
